import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'

export type GuidanceStatusType = `ready` | `partial` | `pending`

interface Response {
  status: GuidanceStatusType
}

type RemediationGuidanceStatusArgs = {
  organizationId: string
  applicationId: string
  remediationGuidanceId: string
}

export async function getRemediationGuidanceStatus(
  this: ThisConnector,
  {
    organizationId,
    applicationId,
    remediationGuidanceId
  }: RemediationGuidanceStatusArgs
) {
  return this.connector.get(
    `/api/ui/organizations/${organizationId}/applications/${applicationId}/remediation/guidance/${remediationGuidanceId}/status`
  )
}

export function useFetchRemediationGuidanceStatus({
  organizationId,
  applicationId,
  remediationGuidanceId,
  enabled
}) {
  return useContrastQuery<RemediationGuidanceStatusArgs, Response>(
    [
      Query.AIML_REMEDIATION_GUIDANCE_STATUS,
      organizationId,
      applicationId,
      remediationGuidanceId
    ],
    getRemediationGuidanceStatus,
    {
      organizationId,
      applicationId,
      remediationGuidanceId
    },
    {
      refetchInterval: 500,
      enabled
    }
  )
}
